import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { take } from 'rxjs';
import { PatientManagerListService } from 'src/patient-manager/services/patient-manager-list.service';

@Component({
    selector: 'app-review-transfer-patient-dialog',
    templateUrl: './review-transfer-patient-dialog.component.html',
    styleUrls: ['./review-transfer-patient-dialog.component.css'],
    standalone: false
})
export class ReviewTransferPatientDialogComponent {

  currentPatient = this.patientManagerListService.currentPatient
  newPatientShop = this.patientManagerListService.newPatinetShop


  constructor(private dialogRef: MatDialogRef<any>, private patientManagerListService: PatientManagerListService) { }

  ngOnInit(): void
  {
    this.dialogRef.afterClosed().pipe(take(1)).subscribe(() =>
    {

      this.patientManagerListService.clearPatient()

    })
  }


  exit()
  {
    this.patientManagerListService.clearPatient()
    this.dialogRef.close(`Excellent`);
  }

  onSubmit()
  {

    if (this.currentPatient?.patientId && this.newPatientShop?.shopId) this.patientManagerListService.transferPatient(this.currentPatient?.patientId,this.newPatientShop?.shopId)
    this.dialogRef.close(`Excellent`);

  }
}
